{
  "platform.summary": "{tenants, plural, one {# client} other {# clients}} · {sites, plural, one {# site} other {# sites}}, {live} live",
  "platform.generated": "Figures from {when}. Aggregated only; client data is available through the client's own workspace.",
  "platform.stats": "Platform key figures",
  "platform.stat_properties": "Properties available",
  "platform.stat_properties_hint": "of {total} managed, all clients",
  "platform.stat_leads": "Enquiries, 30 days",
  "platform.stat_leads_hint": "excluding spam",
  "platform.spark_leads": "Enquiries per day, last 30 days",
  "platform.stat_builds": "Builds, 30 days",
  "platform.stat_builds_hint": "median {median} per build",
  "platform.spark_builds": "Build time of recent builds",
  "platform.stat_ai": "AI cost this month",
  "platform.stat_ai_hint": "{tokens} tokens processed",
  "platform.clients": "Clients",
  "platform.clients_count": "{count, plural, one {# client} other {# clients}}",
  "platform.col_client": "Client",
  "platform.col_properties": "Properties",
  "platform.col_sites": "Sites and languages",
  "platform.col_leads": "Enquiries 30 d",
  "platform.col_published": "Last published",
  "platform.col_ai": "AI this month",
  "platform.col_open": "Open",
  "platform.plan.basis": "Basic",
  "platform.plan.connect": "Connect",
  "platform.plan.agency": "Agency",
  "platform.members": "{count, plural, one {# user} other {# users}}",
  "platform.sites_live": "{live} of {total} live",
  "platform.languages_live": "{count, plural, =0 {no language live yet} one {# language live} other {# languages live}}",
  "platform.new_count": "{count} new",
  "platform.not_published": "Not published yet",
  "platform.build_took": "build {duration}",
  "platform.revision": "revision {revision}",
  "platform.open_client": "Open",
  "platform.no_membership": "No membership",
  "platform.no_clients": "No clients yet",
  "platform.leads": "Enquiries",
  "platform.leads_chart": "Enquiries per week and channel, last 12 weeks",
  "platform.week_of": "Week of {date}",
  "platform.channel_website": "Website",
  "platform.channel_portal": "Portal",
  "platform.channel_other": "Other",
  "platform.conversion": "Conversion (90 d)",
  "platform.conversion_hint": "{won} won of {closed} closed",
  "platform.conversion_none": "No enquiry won or lost yet",
  "platform.first_response": "First response",
  "platform.first_response_hint": "median per client, 90 days",
  "platform.first_response_none": "No response times recorded yet",
  "platform.funnel": "Enquiries by status, 90 days",
  "platform.funnel_empty": "No enquiries in the last 90 days.",
  "platform.spam_filtered": "{count, plural, one {# message} other {# messages}} recognised as spam and not counted.",
  "platform.properties": "Properties per client",
  "platform.properties_count": "{count, plural, one {# property} other {# properties}}",
  "platform.seg_available": "Available",
  "platform.seg_ready": "Ready, not available",
  "platform.seg_draft": "Draft",
  "platform.builds": "Publications and builds",
  "platform.builds_30": "Builds 30 d",
  "platform.builds_median": "Median",
  "platform.builds_p90": "P90",
  "platform.builds_failed": "Failed",
  "platform.builds_chart": "Build time in seconds per site (production)",
  "platform.builds_stuck_title": "{count, plural, one {# build has} other {# builds have}} been running for more than 30 minutes",
  "platform.builds_stuck_body": "Check the build log under Website in the client's workspace; the worker may not have finished it.",
  "platform.no_builds": "No builds yet",
  "platform.never_built": "Never built",
  "platform.quality": "SEO and performance",
  "platform.all_sites": "All sites",
  "platform.measured_mobile": "mobile, measured {when}",
  "platform.no_measurement": "No successful measurement yet",
  "platform.no_measurement_hint": "Measure the site with Measure now, or run the command below in the project folder.",
  "platform.no_measurement_unpublished": "This site has no publication in BRES yet. A measurement only succeeds if the address already serves a page.",
  "platform.q_performance": "Performance",
  "platform.q_performance_short": "Perf.",
  "platform.q_accessibility": "Accessibility",
  "platform.q_accessibility_short": "Access.",
  "platform.q_best_practices": "Best practices",
  "platform.q_best_practices_short": "Pract.",
  "platform.q_seo": "SEO",
  "platform.locales": "Languages and translation status",
  "platform.locales_for": "Translation status of property texts for {site}",
  "platform.loc_approved": "Approved",
  "platform.loc_review": "In review",
  "platform.loc_stale": "Outdated",
  "platform.loc_missing": "Missing",
  "platform.ai": "AI usage",
  "platform.ai_no_budget": "{spent}, no budget set",
  "platform.ai_tokens_chart": "Tokens per month and client",
  "platform.ai_no_usage": "No AI usage in the last six months.",
  "platform.ai_jobs": "{count, plural, one {# AI task} other {# AI tasks}} in 30 days, {blocked} blocked or failed",
  "platform.channels": "Portals",
  "platform.listings": "{count, plural, one {# listing} other {# listings}}",
  "platform.listings_accepted": "{count} accepted",
  "platform.listings_rejected": "{count} rejected",
  "platform.no_channels": "No portal connections yet",
  "platform.analytics": "Google Analytics and Search Console",
  "platform.link_todo": "not connected yet",
  "platform.link_awaiting": "set up, waiting for the first fetch",
  "platform.link_connected": "connected",
  "platform.credentials_missing": "No service account set up yet. Without one, BRES does not fetch or show visitor or search figures.",
  "platform.credentials_present": "Service account set up. Figures appear after the first fetch.",
  "platform.sites_title": "Sites and SEO",
  "platform.sites_count": "{count, plural, one {# site} other {# sites}}",
  "platform.form_label": "Device",
  "platform.form_mobile": "Mobile",
  "platform.form_desktop": "Desktop",
  "platform.measure_title": "Measured locally with Lighthouse",
  "platform.measure_body": "Measure now queues a measurement for the worker: Lighthouse runs locally in its own headless Chromium against the site's address, mobile and desktop, and stores the result. Without a worker you can also run this command in the project folder.",
  "platform.no_sites": "No sites yet",
  "platform.open_site": "Open {site} in a new tab",
  "platform.view_site": "View site",
  "platform.history_for": "Performance and SEO of {site} over time",
  "platform.history": "Scores over time",
  "platform.history_one": "After a second measurement you will see the trend here.",
  "platform.measured_at": "Measured {when}",
  "platform.details": "Details",
  "platform.scores": "Scores",
  "platform.vital_lcp": "Largest Contentful Paint",
  "platform.vital_fcp": "First Contentful Paint",
  "platform.vital_tbt": "Total Blocking Time",
  "platform.vital_cls": "Cumulative Layout Shift",
  "platform.vital_si": "Speed Index",
  "platform.vital_ttfb": "Server response time",
  "platform.tool_line": "Lighthouse {version} · {url} · {when}",
  "platform.last_run_failed": "Last measurement failed ({when})",
  "platform.issues": "What lowers the score",
  "platform.issues_none": "No failed checks in the latest measurement",
  "platform.cat.performance": "Performance",
  "platform.cat.accessibility": "Accessibility",
  "platform.cat.best-practices": "Best practices",
  "platform.cat.seo": "SEO",
  "platform.runs": "All measurements",
  "platform.runs_count": "{count, plural, one {# measurement} other {# measurements}}",
  "platform.no_runs": "No measurements yet",
  "platform.col_when": "Measured",
  "platform.col_status": "Result",
  "platform.col_duration": "Duration",
  "platform.run_ok": "Succeeded",
  "platform.run_failed": "Failed",
  "platform.analytics_note": "BRES only reads. Without a service account, a property and access in Google, a connection stays not connected; no figures are estimated or filled in.",
  "platform.evidence_line": "{level} · checked on {date}",
  "platform.link_status.not_configured": "Not connected yet",
  "platform.link_status.awaiting_credentials": "Waiting for service account",
  "platform.link_status.awaiting_first_sync": "Waiting for first fetch",
  "platform.link_status.connected": "Connected",
  "platform.link_status.error": "Fetch failed",
  "platform.step_credentials": "Service account in BRES_GOOGLE_SERVICE_ACCOUNT_FILE",
  "platform.step_credentials_ok": "Service account {email}",
  "platform.step_ref_ga": "GA4 property ID of this site",
  "platform.step_ref_gsc": "Search Console property of this site",
  "platform.step_access": "Service account has read access in Google (confirmed by the first fetch)",
  "platform.ref_label_ga": "GA4 property ID",
  "platform.ref_label_gsc": "Search Console property",
  "platform.ref_hint_ga": "Digits only, found under Admin > Property settings.",
  "platform.ref_hint_gsc": "sc-domain:domain.es or a URL prefix such as https://www.domain.es/",
  "platform.ref_invalid_google_analytics_4": "A GA4 property ID has 6 to 12 digits.",
  "platform.ref_invalid_google_search_console": "Use sc-domain:domain.es or an https address ending in /.",
  "platform.ref_save": "Save",
  "platform.ref_clear": "Clear",
  "platform.link_saved": "{name} set",
  "platform.link_cleared": "{name} cleared",
  "platform.sync_command": "Fetch figures",
  "platform.last_sync": "Last fetched {when}",
  "platform.no_access_title": "Platform administrators only",
  "platform.no_access_body": "This part of BRES is for the BRES team. Manage your own organisation through the menu on the left.",
  "platform.leads_90": "Enquiries, 90 days",
  "platform.site_info": "Site",
  "platform.client": "Client",
  "platform.live": "Live",
  "platform.live_line": "revision {revision}, live {when}",
  "platform.hosts": "Addresses",
  "platform.host_kind.production": "production",
  "platform.host_kind.preview": "preview",
  "platform.host_kind.local": "local",
  "platform.languages": "Languages",
  "platform.open_workspace": "Open the client's workspace",
  "platform.no_membership_hint": "You have no membership with this client. Client data is only available with temporary support access.",
  "platform.step_credentials_invalid": "The key file in BRES_GOOGLE_SERVICE_ACCOUNT_FILE is not a valid service account",
  "platform.measure_now": "Measure now",
  "platform.measure_waiting": "Waiting for worker",
  "platform.measuring": "Measuring",
  "platform.measure_requested": "Measurement requested",
  "platform.measure_requested_body": "Lighthouse measures mobile and desktop as soon as the worker picks up the task.",
  "platform.measure_queued_title": "Measurement requested at {time}",
  "platform.measure_queued_body": "The worker will pick up the task shortly; this page refreshes by itself.",
  "platform.measure_stuck_title": "Measurement has been waiting since {time} and has not been picked up",
  "platform.measure_stuck_body": "No worker seems to be running. Start the local environment with pnpm dev and the measurement will still go ahead.",
  "platform.measure_running_title": "Lighthouse is measuring mobile and desktop",
  "platform.measure_running_body": "This usually takes about half a minute. The scores appear here by themselves.",
  "platform.measure_failed_title": "Measurement could not be carried out ({time})",
  "platform.measure_done": "Measurement of {site} finished",
  "platform.measure_done_body": "Mobile: performance {performance}, SEO {seo}.",
  "platform.measure_done_failed_runs": "Lighthouse could not load the site properly; the reason is listed with the measurements.",
  "platform.measure_failed": "Measurement of {site} failed",
  "platform.at_time": "at {time}",
  "platform.on_date": "on {date}",
  "platform.demo": "Demo",
  "platform.bres.no_member_title": "No access to the BRES environment",
  "platform.bres.no_member_body": "The blog and chatbot of the BRES site live in the organisation BRES (own environment). Ask an owner to add you.",
  "platform.ai.title": "AI options per client",
  "platform.ai.lead": "AI is a paid extension. Switch features on per client or per site, agree a monthly cap and handle requests.",
  "platform.ai.test_title": "The test adapter is running locally",
  "platform.ai.test_body": "No language model is connected: drafts and answers come from a recognisable test adapter and cost nothing. A real provider needs a key and budget approval.",
  "platform.ai.requests_title": "{count, plural, one {One request from a client} other {# requests from clients}}",
  "platform.ai.request_line": "{tenant} asks for {feature}",
  "platform.ai.enable": "Switch on",
  "platform.ai.disable": "Switch off",
  "platform.ai.close_request": "Close",
  "platform.ai.sites": "{count, plural, one {# site} other {# sites}}",
  "platform.ai.month": "AI costs this month",
  "platform.ai.of_cap": "Use of the cap",
  "platform.ai.cap_value": "of {cap}",
  "platform.ai.no_cap": "No cap agreed",
  "platform.ai.cap_set": "Cap {cap} per month",
  "platform.ai.cap_none": "no cap",
  "platform.ai.own_budget": "client's own budget {budget}",
  "platform.ai.cap_edit": "Cap",
  "platform.ai.cap_title": "Monthly cap for {tenant}",
  "platform.ai.cap_body": "The cap is always a hard limit, even when the client sets a higher budget themselves.",
  "platform.ai.cap_amount": "Cap per month",
  "platform.ai.cap_clear": "Clear cap",
  "platform.ai.cap_saved": "Cap saved",
  "platform.ai.features_label": "AI features of {tenant}",
  "platform.ai.usage": "{count, plural, one {# task} other {# tasks}} · {cost}",
  "platform.ai.no_usage": "Not used this month",
  "platform.ai.changed_by": "{name}, {date}",
  "platform.ai.by_migration": "Carried over (already existed)",
  "platform.ai.by_seed": "Demo plan",
  "platform.ai.never": "Never switched on",
  "platform.ai.confirm_on": "Switch on {feature}?",
  "platform.ai.confirm_off": "Switch off {feature}?",
  "platform.ai.confirm_on_body": "For {target}. The client can use the feature afterwards; costs count towards the cap.",
  "platform.ai.confirm_off_body": "For {target}. The API refuses the feature immediately; after a new publication the site no longer shows it.",
  "platform.ai.note": "Note",
  "platform.ai.note_hint": "For example the reason or the contract. Goes into the audit log.",
  "platform.ai.republish": "Republish the site now, so the blog or chatbot appears or disappears",
  "platform.ai.enabled_toast": "Feature switched on",
  "platform.ai.disabled_toast": "Feature switched off",
  "platform.ai.republished": "New publication r{revision} started.",
  "platform.ai.history_title": "Changes",
  "platform.ai.history_lead": "Who changed what and when, from the platform audit.",
  "platform.ai.history_empty": "No changes yet",
  "platform.ai.h_on": "switched on {feature} for {target}",
  "platform.ai.h_off": "switched off {feature} for {target}",
  "platform.ai.h_cap": "set the cap of {tenant} to {cap}",
  "platform.ai.h_request": "closed a request",
  "platform.ai.on": "On",
  "platform.ai.off": "Off"
}
